import { breadcrumbSchema, clinicListSchema } from "../structured-data-core";
import { clinicsIn } from "../clinics";

// A hub page lists the clinics and links to each clinic's own page. The
// clinic nodes live on those pages, not here.
export function getMidwestStructuredData() {
  return [
    clinicListSchema("RESTORE Hair clinics in the Midwest", "/locations/restore-midwest/", clinicsIn("chicago")),
    breadcrumbSchema([
      { name: "Locations", path: "/locations/" },
      { name: "Midwest", path: "/locations/restore-midwest/" },
    ]),
  ];
}
